<template>
  <div class="relative inline-block text-left">
    <div class="inline-flex min-h-full">
      <button type="button" :class="{'cursor-not-allowed': disabled}" @click="open">
        <slot/>
      </button>
    </div>

    <transition enter-active-class="transition ease-out duration-100"
                enter-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
      <div v-if="show && !disabled"
           class="absolute mt-2 rounded-md shadow-lg z-10"
           style="width: 500px;"
           :class="{'origin-top-right right-0': origin === 'top-right', 'origin-top-left left-0': origin === 'top-left'}"
      >
        <div style="position: fixed; top: 0; right: 0; left: 0; bottom: 0;" class="z-10 transition ease-in" @click="close" />
        <div ref="dropdown" class="relative bg-white shadow-xs z-50 rounded-md border border-gray-200"
        >
          <div style="max-height: 260px;overflow:auto;">
            <slot name="dropdown"/>
          </div>
          <div v-if="$slots.footer" class="rounded-b-md p-2 border-t border-gray-200">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'OrderItemsSelect',
  props: {
    origin: {
      type: String,
      default: 'top-right',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      show: false,
    }
  },

  methods: {
    open() {
      if (!this.disabled) {
        this.show = !this.show
        document.body.classList.add('overflow-hidden');
      }
    },
    close() {
      this.show = false
      document.body.classList.remove('overflow-hidden');
    }
  },

  mounted() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.show) {
        this.show = false
      }
    })
  },
}
</script>
